var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"guest-registration"},[_c('p',{staticClass:"guest-registration__title text-center font-gilroy font-bold mb-4"},[_vm._v(_vm._s(_vm.formInfo.Title))]),_vm._v(" "),_c('div',{staticClass:"app-styled-form"},[_c('div',{ref:"mountFormHere"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }